/**
 * ConfirmModal — diálogo de confirmación genérico (reemplaza window.confirm).
 * Mismo estilo visual que los demás modales del módulo financiero.
 */
import { useTranslation } from "react-i18next";
import { overlayClose } from "../../../shared/utils/overlayClose";

const OVERLAY = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.65)",
  zIndex: 1000,
  backdropFilter: "blur(3px)",
};

const MODAL_BASE = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%,-50%)",
  background: "var(--bg-card)",
  border: "1px solid var(--border-card)",
  borderRadius: 12,
  padding: "22px 24px 20px",
  width: "min(440px, 92vw)",
  zIndex: 1001,
  boxShadow: "0 24px 64px rgba(0,0,0,0.55)",
};

export default function ConfirmModal({
  title,
  message,
  confirmLabel,
  cancelLabel,
  danger = true,
  loading = false,
  onConfirm,
  onCancel,
}) {
  const { t } = useTranslation();
  return (
    <>
      <div {...overlayClose(onCancel)} style={OVERLAY} />
      <div style={MODAL_BASE}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
          <i
            className="fa-solid fa-triangle-exclamation"
            style={{ color: danger ? "#f87171" : "#60a5fa", fontSize: "1.15rem" }}
          />
          <h3 style={{ margin: 0, color: "var(--text-primary)", fontSize: "1rem", fontWeight: 700 }}>
            {title}
          </h3>
        </div>
        <p style={{ margin: "0 0 18px", color: "var(--text-secondary)", fontSize: "0.85rem", lineHeight: 1.5 }}>
          {message}
        </p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <button
            onClick={onCancel}
            disabled={loading}
            style={{
              padding: "8px 16px",
              background: "transparent",
              border: "1px solid var(--border-card)",
              borderRadius: 7,
              color: "var(--text-muted)",
              fontSize: "0.84rem",
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {cancelLabel ?? t("common.cancelar")}
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            style={{
              padding: "8px 18px",
              background: danger ? "#f87171" : "#a78bfa",
              color: "#fff",
              border: "none",
              borderRadius: 7,
              fontSize: "0.84rem",
              fontWeight: 600,
              cursor: loading ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              gap: 7,
            }}
          >
            {loading ? (
              <>
                <i className="fa-solid fa-circle-notch fa-spin" /> {t("common.eliminando")}
              </>
            ) : (
              confirmLabel ?? t("common.eliminar")
            )}
          </button>
        </div>
      </div>
    </>
  );
}
